import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const router = new Router({
  // base: "/mechanism/",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "wyHome",
      // redirect: "main"
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/login.vue"),
    },
    {
      path: "/authentication",
      name: "authentication",
      component: () => import("../views/authentication/authentication.vue"),
    },
    {
      path: "/wyHome",
      name: "wyHome",
      component: () => import("../views/wyHome.vue"),
    },
    {
      path: "/xy",
      name: "xy",
      component: () => import("../views/xyIndex.vue"),
    },
    {
      path: "/Agencyapplet",
      name: "Agencyapplet",
      component: () => import("../views/applet/Agencyapplet.vue"),
    },
    {
      path: "/coachapplet",
      name: "coachapplet",
      component: () => import("../views/applet/coachapplet.vue"),
    },
    {
      path: "/Downloadapplet",
      name: "Downloadapplet",
      component: () => import("../views/applet/Downloadapplet.vue"),
    },
    {
      path: "/Merchantapplet",
      name: "Merchantapplet",
      component: () => import("../views/applet/Merchantapplet.vue"),
    },

    {
      path: "/main",
      name: "main",
      component: () => import("../views/main.vue"),
      redirect: {
        name: "Home",
      },
      children: [
        {
          path: "timHome",
          name: "timHome",
          component: () => import("../views/timMessage/timHome.vue"),
        },
        {
          path: "wyneed",
          name: "wyneed",
          component: () => import("../views/timMessage/wyneed.vue"),
        },
        {
          path: "Teachingtype",
          name: "Teachingtype",
          component: () => import("../views/UserDetails/Teachingtype.vue"),
        },
        {
          path: "Bindingmechanism",
          name: "Bindingmechanism",
          component: () => import("../views/HomeList/Bindingmechanism.vue"),
        },
        {
          path: "activity",
          name: "activity",
          component: () => import("../views/activity/activity.vue"),
        },
        {
          path: "ModifyAuthentication",
          name: "ModifyAuthentication",
          component: () =>
            import("../views/UserDetails/ModifyAuthentication.vue"),
        },
        {
          path: "attestation",
          name: "attestation",
          component: () => import("../views/UserDetails/attestation.vue"),
        },
        {
          path: "UserDetails",
          name: "UserDetails",
          component: () => import("../views/UserDetails/UserDetails.vue"),
        },
        {
          path: "CertifiedCoach",
          name: "CertifiedCoach",
          component: () => import("../views/HomeList/CertifiedCoach.vue"),
        },

        {
          path: "notice",
          name: "notice",
          component: () => import("../views/Myhome/notice.vue"),
        },
        {
          path: "Mysetup",
          name: "Mysetup",
          component: () => import("../views/Mysetup/Mysetup.vue"),
        },
        {
          path: "Menuhall",
          name: "Menuhall",
          component: () => import("../views/HomeList/Menuhall.vue"),
        },
        {
          path: "MyOrder",
          name: "MyOrder",
          component: () => import("../views/HomeList/MyOrder.vue"),
        },
        {
          path: "NewCourse",
          name: "NewCourse",
          component: () => import("../views/HomeList/NewCourse.vue"),
        },
        {
          path: "Coursepage",
          name: "Coursepage",
          component: () => import("../views/HomeList/Coursepage.vue"),
        },
        {
          path: "OrderRecord",
          name: "OrderRecord",
          component: () => import("../views/HomeList/OrderRecord.vue"),
        },
        {
          path: "Home",
          name: "Home",
          component: () => import("../views/Home.vue"),
        },
        {
          path: "MessagePage",
          name: "MessagePage",
          component: () => import("../views/Myhome/MessagePage.vue"),
        },
        {
          path: "SwitchPages",
          name: "SwitchPages",
          component: () => import("../views/SwitchPages.vue"),
        },
        {
          path: "curriculum",
          name: "curriculum",
          component: () => import("../views/HomeList/curriculum.vue"),
        },
        {
          path: "Venue",
          name: "Venue",
          component: () => import("../views/HomeList/Venue.vue"),
        },
        {
          path: "VenueService",
          name: "VenueService",
          component: () => import("../views/HomeList/VenueService.vue"),
        },
        {
          path: "Appointmentpage",
          name: "Appointmentpage",
          component: () => import("../views/HomeList/Appointmentpage.vue"),
        },
        {
          path: "DevicePage",
          name: "DevicePage",
          component: () => import("../views/HomeList/DevicePage.vue"),
        },
        {
          path: "TodaysCourse",
          name: "TodaysCourse",
          component: () => import("../views/HomeList/TodaysCourse.vue"),
        },
        {
          path: "agencyPang",
          name: "agencyPang",
          component: () => import("../views/HomeList/agencyPang.vue"),
        },
        {
          path: "Newpage",
          name: "Newpage",
          component: () => import("../views/HomeList/Newpage.vue"),
        },
        {
          path: "Writeoffpage",
          name: "Writeoffpage",
          component: () => import("../views/HomeList/Writeoffpage.vue"),
        },
        {
          path: "InstructorPage",
          name: "InstructorPage",
          component: () => import("../views/HomeList/InstructorPage.vue"),
        },
        {
          path: "RowcoursePoag",
          name: "RowcoursePoag",
          component: () => import("../views/HomeList/RowcoursePoag.vue"),
        },
        {
          path: "Courseschedulepage",
          name: "Courseschedulepage",
          component: () => import("../views/HomeList/Courseschedulepage.vue"),
        },
        {
          path: "HelpPage",
          name: "HelpPage",
          component: () => import("../views/HelpHome/HelpPage.vue"),
        },
        {
          path: "Feedback",
          name: "Feedback",
          component: () => import("../views/HelpHome/Feedback.vue"),
        },
        {
          path: "currentversion",
          name: "currentversion",
          component: () => import("../views/HelpHome/currentversion.vue"),
        },
        {
          path: "HelpHome",
          name: "HelpHome",
          component: () => import("../views/HelpHome/HelpHome.vue"),
        },
        {
          path: "unionList",
          name: "unionList",
          component: () => import("../views/union/unionList/unionList.vue"),
        },
        {
          path: "createUnion",
          name: "createUnion",
          component: () => import("../views/union/unionInfo/createUnion.vue"),
        },
        {
          path: "unionDesc",
          name: "unionDesc",
          component: () => import("../views/union/unionInfo/unionDesc.vue"),
        },
        {
          path: "unionCenter",
          name: "unionCenter",
          component: () => import("../views/union/unionInfo/unionCenter.vue"),
        },
        {
          path: "memberManage",
          name: "memberManage",
          component: () => import("../views/union/memberManage/memberManage.vue"),
        },
        {
          path: "orderManage",
          name: "orderManage",
          component: () => import("../views/union/orderManage/orderManage.vue"),
        },
        {
          path: "sendOrder",
          name: "sendOrder",
          component: () => import("../views/union/orderManage/sendOrder.vue"),
        },
        {
          path: "classManage",
          name: "classManage",
          component: () => import("../views/union/classManage/classManage.vue"),
        },
        {
          path: "createClass",
          name: "createClass",
          component: () => import("../views/union/classManage/createClass.vue"),
        },
        {
          path: "changeCoach",
          name: "changeCoach",
          component: () => import("../views/union/classManage/changeCoach.vue"),
        },
        {
          path: "stuList",
          name: "stuList",
          component: () => import("../views/union/studentManage/studentList.vue"),
        },
        {
          path: "myApply",
          name: "myApply",
          component: () => import("../views/union/applyList/myApplyList.vue"),
        },
        {
          path: "Myhome",
          name: "Myhome",
          component: () => import("../views/Myhome/Myhome.vue"),
          redirect: {
            name: "MyPage",
          },
          children: [
            {
              path: "MyPage",
              name: "MyPage",
              component: () => import("../views/Myhome/MyPage.vue"),
            },

            {
              path: "mechanism",
              name: "mechanism",
              component: () => import("../views/Myhome/mechanism.vue"),
            },
            {
              path: "BondPage",
              name: "BondPage",
              component: () => import("../views/Myhome/BondPage.vue"),
            },
            {
              path: "Finance",
              name: "Finance",
              component: () => import("../views/Myhome/Finance.vue"),
            },
            {
              path: "venueList",
              name: "venueList",
              component: () => import("../views/Myhome/venueList.vue"),
            },
            {
              path: "CommentPage",
              name: "CommentPage",
              component: () => import("../views/Myhome/CommentPage.vue"),
            },
            {
              path: "customerservice",
              name: "customerservice",
              component: () => import("../views/Myhome/customerservice.vue"),
            },
            {
              path: "OccupancyAgreement",
              name: "OccupancyAgreement",
              component: () =>
                import("../views/Mysetup/components/OccupancyAgreement.vue"),
            },
          ],
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("usertoken");
  if (!token && to.path != "/login") {
    if (to.path == "/wyHome" || to.path == "/xy") {
      next();
      return;
    }
    router.push({
      name: "login",
    });
    next();
  } else {
    next();
  }
});
export default router;
